import { SimpleError } from "@simonbackx/simple-errors";
export class MapDecoder {
    constructor(keyDecoder, valueDecoder) {
        this.keyDecoder = keyDecoder;
        this.valueDecoder = valueDecoder;
    }
    decode(data) {
        if (typeof data.value === 'object' && data.value !== null) {
            const map = new Map();
            for (const key in data.value) {
                const keyDecoded = data.clone({
                    data: key,
                    context: data.context,
                    field: data.addToCurrentField(key)
                }).decode(this.keyDecoder);
                const valueDecoded = data.field(key).decode(this.valueDecoder);
                map.set(keyDecoded, valueDecoded);
            }
            return map;
        }
        throw new SimpleError({
            code: "invalid_field",
            message: `Expected an object at ${data.currentField}`,
            field: data.currentField,
        });
    }
}
//# sourceMappingURL=MapDecoder.js.map